<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="amerces"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <!--        <el-button type="primary" :disabled="!selection.length" @click="printHandle"> 打印 </el-button>-->
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="登记日期">
            <el-date-picker
                v-model="createTime"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="createTimeChange"/>
          </el-form-item>
          <el-form-item label="编号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入编号" clearable/>
          </el-form-item>
          <el-form-item label="供应商编码">
            <el-input v-model.trim="filter.supplierCode" placeholder="请输入供应商编码" clearable/>
          </el-form-item>
          <el-form-item label="供应商名称">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入供应商名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.subAuth"
            type="primary"
            :disabled="scope.row.status === 0"
            :loading="submitLoading"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
      </template>
    </viewTable>
    <amerce-edit ref="amerceEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import AmerceEdit from "@/views/inspection/Amerce/AmerceEdit";
  export default {
    name: "AppointmentOrder",
    components: {AmerceEdit, viewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(572),
          editAuth: this.$auth(573),
          delAuth: this.$auth(574),
          subAuth: this.$auth(575),
        },
        submitLoading: false,
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        selection: [],
        createTime: "",
        filter: {
          billNo: "",
          beginCreateTime: "",
          endCreateTime: "",
          factoryNo: "",
          salesmanName: "",
          customerName: "",
          creatorName: "",
          serviceAddress: "",
          contact: "",
          siteMobile: "",
          status: "",
          supplierCode: "",
          supplierName: "",
        },
        columnsProperty: [
          {
          tooltip: true,
            key: "billNo",
            align: "center",
            width: 150,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/AmercePreview",
                        query: {
                          billType: 13,
                          billId: params.row.pkid,
                          $tabName: params.row.billNo,
                        },
                      });
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
          tooltip: true,
            key: "creatorName",
            align: "center",
            width: 120,
          },
          {
          tooltip: true,
            key: "supplierName",
            align: "center",
            width: 210,
          },
          {
          tooltip: true,
            key: "orderReturnReasonName",
            align: "center",
            width: 120,
          },
          {
          tooltip: true,
            key: "typeName",
            align: "center",
            width: 120,
          },
          {
          tooltip: true,
            key: "createTime",
            align: "center",
            width: 160,
          },
          {
            key: "action",
            align: "center",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.amerceEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.get("basic", `replacementBills/submitOA/${row.pkid}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.submitLoading = false;
              this.loadData();
            } else {
              this.submitLoading = false;
            }
          }).catch(() => {
            this.submitLoading = false;
          },
          );
        });
      },
      createTimeChange(date) {
        if (date !== null) {
          this.filter.beginCreateTime = date[0];
          this.filter.endCreateTime = date[1];
        } else {
          this.filter.beginCreateTime = "";
          this.filter.endCreateTime = "";
        }
      },
      deleteHandle(row) {
        this.$http.delete("basic", "amerces", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = filter;
      },

      otherAuth(row) {
        return row.status === 0;
      },
    },
  };
</script>
